import { useState } from "react";
//@dependencies
import PropTypes from "prop-types";
import classNames from "classnames";
//@mui
import { Grid2, Snackbar, Stack, Tooltip } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import { copyTextToClipboard } from "../../Utils/utils";
//styles
import styles from "./CustomInput.module.scss";

export default function CustomInput(props) {
  //props
  const {
    type,
    title,
    SubTitle,
    placeholder,
    value,
    setValue,
    password,
    error,
    errorMessage,
    suffix,
    icon,
    iconClick,
    passwordview,
    frontEndorment,
    frontEndormentWidthAdjustment,
    disabled,
    tooltip,
    tooltipMessage,
    nameLoading,
    className,
    inputStyle,
    fontSize,
    multiline,
    titleAction,
    // copy icon inside the field: copies exactly what the field holds (its value prop)
    copyable,
    ...rest
  } = props;

  const [view, setView] = useState(false);
  const [copied, setCopied] = useState(false);

  const copyValue = async () => {
    if (await copyTextToClipboard(value)) setCopied(true);
  };

  return (
    <Stack
      className={`${classNames(styles.customInputContainer)} ${className}`}
    >
      <div
        className={
          title
            ? type === "AUTH"
              ? styles.customInputTitleAuth
              : styles.customInputTitle
            : styles.displayNone
        }
      >
        <Grid2
          className={`${type === "AUTH" ? styles.customInputTitleAuth : styles.customInputTitle} ${titleAction ? styles.titleRow : ""}`}
        >
          <span className={`${fontSize ? styles.fontSize : ""}`}>{title}</span>
          {SubTitle ? (
            <Grid2 className={styles.customInputSubTitle}>{SubTitle}</Grid2>
          ) : (
            ""
          )}
          {titleAction && <span className={styles.titleAction}>{titleAction}</span>}
        </Grid2>
      </div>
      <div className={styles.positionRelative}>
        {multiline ? (
          <textarea
            {...rest}
            disabled={disabled}
            value={value}
            placeholder={placeholder}
            onChange={(e) => setValue(e.target.value, title, e)}
            rows={5}
            spellCheck={false}
            className={`${classNames({
              [type === "AUTH"
                ? error
                  ? styles.customInputTextFieldErrorAuth
                  : styles.customInputTextFieldAuth
                : error
                ? styles.customInputTextfielderror
                : styles.customInputTextfield]: true,
              [styles.tooltipWrapper]: tooltip,
            })} ${styles.customInputTextarea} ${inputStyle}`}
          />
        ) : (
        <input
          {...rest}
          disabled={disabled}
          value={value}
          placeholder={placeholder}
          onChange={(e) => {
            setValue(e.target.value, title, e);
          }}
          style={{
            paddingLeft: frontEndorment ? "42px" : null,
            width: frontEndormentWidthAdjustment ? "calc(96% - 32px)" : "",
          }}
          className={`${classNames({
            [type === "AUTH"
              ? error
                ? styles.customInputTextFieldErrorAuth
                : styles.customInputTextFieldAuth
              : error
              ? styles.customInputTextfielderror
              : styles.customInputTextfield]: true,
            [styles.popupBlocker]: password && !view,
            [styles.tooltipWrapper]: tooltip,
          })} ${inputStyle}`}
        />
        )}
        {frontEndorment && (
          <span className={styles.prefix}>{frontEndorment}</span>
        )}
        {passwordview && (
          <span className={styles.suffix}>
            {view && (
              <div
                className={styles.cursorPointer}
                onClick={() => {
                  setView(!view);
                }}
              >
                <VisibilityOff className={styles.viewicon} />
              </div>
            )}
            {!view && (
              <div
                className={styles.cursorPointer}
                onClick={() => {
                  setView(!view);
                }}
              >
                <Visibility className={styles.viewicon} />
              </div>
            )}
          </span>
        )}
        {copyable && !multiline && (
          <span
            className={passwordview ? styles.copyIconWithView : styles.copyIcon}
          >
            <div
              className={styles.cursorPointer}
              role="button"
              aria-label={`Copy ${title || "value"}`}
              title="Copy"
              onClick={copyValue}
            >
              <FileCopyOutlinedIcon className={styles.viewicon} />
            </div>
          </span>
        )}
        {suffix && <span className={styles.suffix}>{suffix}</span>}
        {icon && (
          <span className={styles.icon} onClick={iconClick}>
            {icon}
          </span>
        )}
        {tooltip && (
          <span
            style={{
              position: "absolute",
              right: "-25px",
              top: "20px",
              color: "#777",
            }}
          >
            <Tooltip disableFocusListener title={tooltipMessage}>
              <InfoIcon fontSize="small" />
            </Tooltip>
          </span>
        )}
        {/* {nameLoading && (
          <CircularProgress
            size={20}
            style={{
              position: "absolute",
              right: "20px",
              top: "30%",
              transform: "translateY(-50%)",
            }}
          />
        )} */}
        {error && <div className={styles.errorText}>{errorMessage}</div>}
      </div>
      {copyable && (
        <Snackbar
          open={copied}
          autoHideDuration={2000}
          onClose={() => setCopied(false)}
          message="Copied to clipboard"
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        />
      )}
    </Stack>
  );
}

//types
CustomInput.propTypes = {
  type: PropTypes.oneOf(["ADMIN", "AUTH"]), //ADMIN is the default type
  title: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  password: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  suffix: PropTypes.string,
  passwordview: PropTypes.bool,
  disabled: PropTypes.bool,
  frontEndorment: PropTypes.any,
  frontEndormentWidthAdjustment: PropTypes.bool,
  tooltip: PropTypes.bool,
  tooltipMessage: PropTypes.string,
  nameLoading: PropTypes.bool,
  copyable: PropTypes.bool,
};
